module.exports = __webpack_public_path__ + "img/Group 850.27272fdb.png";